export const PLUGIN_PREFIX = 'madden-banners';
